<style lang="stylus">
    .ft-tablemore
        background $ft-bgcolor
        box-shadow $ft-boxshadow
        border-radius $ft-boxradius
        padding 6px
        .dvline
            width calc(100% - 20px)
            height 1px
            background var(--border-color-box-6)
            margin 4px auto
        .ft-menu .ft-menuicon.active
            background transparent
        .ivu-checkbox-default
            margin 8px
            &:not(.ivu-checkbox-checked)
                .ivu-checkbox-inner
                    background-color var(--bg-color-tertiary)
</style>

<template>
    <div class="ft-tablemore">
        <FTSubMenu :imgIcon="'table-margin'" :text="$t('margin')" :isExpand="true" @mousedown.native.stop>
            <template #content>
                <div class="ft-tablemore">
                    <FtMenu
                        v-for="item in marginList"
                        :key="item.id"
                        :imgIcon="item.icon"
                        :text="$t(`marginList.${item.label}`)"
                        rectChecked="true"
                        :checked="margins[item.id]"
                        @click.native="clickTableList(item.label)"
                    />
                </div>
            </template>
        </FTSubMenu>
        <FTSubMenu :imgIcon="'table-border'" :text="$t('border')" :isExpand="true" @mousedown.native.stop>
            <template #content>
                <div class="ft-tablemore">
                    <FtMenu
                        v-for="item in borderList1"
                        :key="item.id"
                        :imgIcon="item.icon"
                        :text="$t(`borderList.${item.label}`)"
                        rectChecked="true"
                        :checked="borders[item.id]"
                        @click.native="clickTableList('border', item.id)"
                    />
                    <div class="dvline"></div>
                    <FtMenu
                        v-for="item in borderList2"
                        :key="item.id"
                        :imgIcon="item.icon"
                        :text="$t(`borderList.${item.label}`)"
                        rectChecked="true"
                        :checked="borders[item.id]"
                        @click.native="clickTableList('border', item.id)"
                    />
                    <div class="dvline"></div>
                    <FtMenu
                        v-for="item in borderList3"
                        :key="item.id"
                        :imgIcon="item.icon"
                        :text="$t(`borderList.${item.label}`)"
                        rectChecked="true"
                        :checked="borders[item.id]"
                        @click.native="clickTableList('border', item.id)"
                    />
                </div>
            </template>
        </FTSubMenu>
        <FtMenu :imgIcon="'table-sizeRow'" :text="$t('distriRow')" @click.native="clickTableList('distriRow')" :isExpand="true" :hideExpand="true" />
        <FtMenu :imgIcon="'table-sizeCol'" :text="$t('distriCol')" @click.native="clickTableList('distriCol')" :isExpand="true" :hideExpand="true" />
        <FTSubMenu :imgIcon="'table-function'" :text="$t('function')" :isExpand="true" v-if="rowNum > 1" @mousedown.native.stop>
            <template #content>
                <div class="ft-tablemore">
                    <Checkbox
                        v-for="item in tableTraitsList"
                        :key="item.id"
                        v-model="tableTraits[item.id]"
                        @on-change="clickTableList(item.label)"
                        style="min-width: max-content"
                    >
                        {{ $t(`sumList.${item.label}`) }}
                    </Checkbox>
                </div>
            </template>
        </FTSubMenu>
        <FtMenu :imgIcon="'float-import'" :text="$t('import')" @click.native="importExcelClick" :isExpand="true" :hideExpand="true" />
        <input ref="excelInput" accept=".xlsx,.csv" type="file" style="display: none" @change="importExcel($event)" />
        <FTSubMenu :imgIcon="'float-export'" :text="$t('export')" :isExpand="true" @mousedown.native.stop>
            <template #content>
                <div class="ft-tablemore">
                    <FtMenu
                        v-for="item in exportList"
                        :key="item.id"
                        :text="$t(`exportList.${item.label}`)"
                        @click.native="exportOperation(item.id)"
                    />
                </div>
            </template>
        </FTSubMenu>
    </div>
</template>

<script lang="ts">
    declare var eTableType: any;
    declare var eFlagExcelImport: any;
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import FTSubMenu from "../public/FTSubMenu.vue";
    import FtMenu from "../public/FtMenu.vue";

    @Component({
        components: {
            FTSubMenu,
            FtMenu,
        },
    })
    export default class TableMore extends Vue {
        @Inject()
        ["showMessage"];

        marginList = [
            {
                id: 0,
                icon: "table-none",
                label: "noneMargin",
            },
            {
                id: 1,
                icon: "table-narrow",
                label: "narrowMargin",
            },
            {
                id: 2,
                icon: "table-normal-margin",
                label: "normalMargin",
            },
            {
                id: 3,
                icon: "table-wide",
                label: "wideMargin",
            },
        ];

        borderList1 = [
            {
                id: 0,
                icon: "table-noBorder",
                label: "noBorder",
            },
            {
                id: 1,
                icon: "table-allBorder",
                label: "allBorder",
            },
            {
                id: 2,
                icon: "table-outsizeBorders",
                label: "outsizeBorder",
            },
            {
                id: 3,
                icon: "table-insideBorders",
                label: "insideBorder",
            },
        ];

        borderList2 = [
            {
                id: 4,
                icon: "table-bottomBorder",
                label: "bottomBorder",
            },
            {
                id: 5,
                icon: "table-topBorder",
                label: "topBorder",
            },
            {
                id: 6,
                icon: "table-leftBorder",
                label: "leftBorder",
            },
            {
                id: 7,
                icon: "table-rightBorder",
                label: "rightBorder",
            },
        ];

        borderList3 = [
            {
                id: 8,
                icon: "table-horizontalBorder",
                label: "horizontalBorder",
            },
            {
                id: 9,
                icon: "table-verticalBorder",
                label: "verticalBorder",
            },
            {
                id: 10,
                icon: "table-downBorder",
                label: "downBorder",
            },
            {
                id: 11,
                icon: "table-upBorder",
                label: "upBorder",
            },
        ];

        tableTraitsList = [
            {
                id: 0,
                label: "sum",
            },
            {
                id: 1,
                label: "average",
            },
            {
                id: 2,
                label: "max",
            },
            {
                id: 3,
                label: "min",
            },
        ];

        exportList = [
            {
                id: 0,
                label: "exportExcel",
            },
            {
                id: 1,
                label: "exportcsv",
            },
        ];

        created() {}
        mounted() {}

        get margins() {
            return this.$store.state.table.margins;
        }

        get borders() {
            return this.$store.state.table.borders;
        }

        get tableTraits() {
            return this.$store.state.table.tableTraits;
        }

        get rowNum() {
            return this.$store.state.table.rowNum;
        }

        clickTableList(type, data) {
            let view = window["_view"];
            if (!view) return;
            switch (type) {
                case "distriRow":
                    view.tableOperation(eTableType.DistriRow);
                    break;
                case "distriCol":
                    view.tableOperation(eTableType.DistriCol);
                    break;
                case "noneMargin":
                    view.tableOperation(eTableType.MarginNo);
                    break;
                case "narrowMargin":
                    view.tableOperation(eTableType.MarginNarrow);
                    break;
                case "normalMargin":
                    view.tableOperation(eTableType.MarginNormal);
                    break;
                case "wideMargin":
                    view.tableOperation(eTableType.MarginWide);
                    break;
                case "sum":
                    view.tableOperation(eTableType.Sum);
                    break;
                case "average":
                    view.tableOperation(eTableType.Average);
                    break;
                case "max":
                    view.tableOperation(eTableType.Max);
                    break;
                case "min":
                    view.tableOperation(eTableType.Min);
                    break;
                case "border":
                    view.tableBorders(data);
                    break;
                default:
                    break;
            }
            this.sensors.track("editTable", {
                Catalogues: "shortcutToolbar",
                content: type,
            });
        }

        isIrregular() {
            if (!window["_view"]) {
                return false;
            } else if (!window["_view"]._activeShape) {
                return false;
            }
            if (!window["_view"]._activeShape.toTable()) {
                return false;
            }
            return window["_view"]._activeShape.toTable().isIrregularTable();
        }

        importExcelClick() {
            (this.$refs.excelInput as any).click();
        }

        importExcel(e) {
            let file = e.target.files[0];
            let reader = new FileReader();
            reader.readAsBinaryString(file);
            reader.onload = (e) => {
                let importExcelData: Array<Array<string>> = [];
                let res = window["_view"].chartImportFromExcel((e.target as any).result, importExcelData);
                if (res === eFlagExcelImport.MulPage) {
                    let msg = this.$t("ExcelTable.MulPage");
                    this.showMessage({
                        type: 2,
                        content: msg,
                    });
                }
                if (importExcelData.length && importExcelData.length * importExcelData[0].length > 1000) {
                    let msg = this.$t("ExcelTable.remindMsg") as string;
                    this.showMessage({
                        sponsor: "importExcel",
                        type: 0,
                        content: msg,
                    });
                } else {
                    let regular = this.isIrregular();
                    if (!regular) {
                        // 规则表
                        let row = 0,
                            line = 0;
                        for (let i = 0; i < importExcelData.length; i++) {
                            row = i + 1;
                            if (importExcelData[i]) {
                                let length = importExcelData[i].length;
                                line = line > length ? line : length;
                            }
                        }
                        window["_view"].setTableDate(row, line, importExcelData);
                    } else {
                        // 不规则表
                        let checkflag = true;
                        let data = this.$store.state.echart.chartData;
                        let regularMap: Array<Array<string>> = [];
                        for (let i = 0; i < data.length; i++) {
                            regularMap.push([]);
                            for (let j = 0; j < data[i].length; j++) {
                                if (data[i][j] != undefined) {
                                    regularMap[i][j] = "";
                                }
                            }
                        }
                        if (importExcelData.length > regularMap.length) checkflag = false;
                        for (let i = 0; i < regularMap.length; i++) {
                            if (!checkflag) break;
                            for (let j = 0; j < importExcelData[i].length; j++) {
                                if (importExcelData[i][j] != "" && j >= importExcelData[i].length) {
                                    checkflag = false;
                                    break;
                                }
                            }
                        }
                        if (!checkflag) {
                            let msg = this.$t("ExcelTable.tableWarn");
                            this.showMessage({
                                sponsor: "regularTable",
                                type: 0,
                                content: msg,
                            });
                        } else {
                            window["_view"].setTableDate(-1, -1, importExcelData);
                        }
                    }
                }
            };
            this.sensors.track("editTable", {
                Catalogues: "shortcutToolbar",
                content: "import",
            });
        }

        exportOperation(id) {
            switch (id) {
                case 0:
                    window["_view"].chartExportToExcel(this.$store.state.table.tableData);
                    break;
                case 1:
                    window["_view"].chartExportToExcel(this.$store.state.table.tableData, "csv");
                    break;
            }
            this.sensors.track("editTable", {
                Catalogues: "shortcutToolbar",
                content: "export",
            });
        }
    }
</script>

<i18n>
{
  "zh": {
    "border": "边框",
    "margin": "边界",
    "function": "函数",
    "distriRow": "平均分布行",
    "distriCol": "平均分布列",
    "import": "导入",
    "export": "导出",
    "borderList": {
        "noBorder": "无框线",
        "bottomBorder": "下框线",
        "allBorder": "所有框线",
        "topBorder": "上框线",
        "outsizeBorder": "外侧框线",
        "leftBorder": "左框线",
        "insideBorder": "内部框线",
        "rightBorder": "右框线",
        "horizontalBorder": "内部横框线",
        "downBorder": "斜下框线",
        "verticalBorder": "内部竖框线",
        "upBorder": "斜上框线"
    },
    "marginList": {
        "noneMargin": "无",
        "narrowMargin": "窄",
        "normalMargin": "普通",
        "wideMargin": "宽"
    },
    "sumList": {
        "sum": "和",
        "average": "平均",
        "max": "最大",
        "min": "最小"
    },
    "exportList": {
        "exportExcel": "导出XLSX",
        "exportcsv": "导出CSV"
    }
  },
  "en": {
    "border": "Border",
    "margin": "Margin",
    "function": "Function",
    "distriRow": "Distribute Rows",
    "distriCol": "Distribute Columns",
    "import": "Import",
    "export": "Export",
    "borderList": {
        "noBorder": "No Border",
        "allBorder": "All Borders",
        "outsizeBorder": "Outside Borders",
        "insideBorder": "Inside Borders",
        "bottomBorder": "Bottom Border",
        "topBorder": "Top Border", 
        "leftBorder": "Left Border",
        "rightBorder": "Right Border",
        "horizontalBorder": "Inside Horizontal Border",
        "verticalBorder": "Inside Vertical Border",
        "downBorder": "Diagonal Down Border",
        "upBorder": "Diagonal Up Border"
    },
    "marginList": {
        "noneMargin": "No Margin",
        "narrowMargin": "Narrow ",
        "normalMargin": "Normal ",
        "wideMargin": "Margin Width"
    },
    "sumList": {
        "sum": "Sum",
        "average": "Average",
        "max": "Maximum",
        "min": "Minimum"
    },
    "exportList": {
        "exportExcel": "Export XLSX",
        "exportcsv": "Export CSV"
    }
  },
  "fr": {
    "border": "Frontière",
    "margin": "Marge",
    "function": "Fonction",
    "distriRow": "Lignes réparties uniformément",
    "distriCol": "Colonnes répartis uniformément",
    "import": "Importer",
    "export": "Exporter",
    "borderList": {
        "noBorder": "Sans cadre",
        "bottomBorder": "Bordure inférieure",
        "allBorder": "Toutes les frontières",
        "topBorder": "Bordure supérieure",
        "outsizeBorder": "Bordures extérieures",
        "leftBorder": "Bordure gauche",
        "insideBorder": "Bordure intérieure",
        "rightBorder": "Bordure droite",
        "horizontalBorder": "Bordure horizontale intérieure",
        "downBorder": "Bordure inférieure oblique",
        "verticalBorder": "Bordure verticale interne",
        "upBorder": "Bordure supérieure Oblique"
    },
    "marginList": {
        "noneMargin": "Aucun",
        "narrowMargin": "Étroit",
        "normalMargin": "Ordinaire",
        "wideMargin": "Largeur"
    },
    "sumList": {
        "sum": "Somme",
        "average": "Moyenne",
        "max": "Max",
        "min": "Min"
    },
    "exportList": {
        "exportExcel": "Exporter XLSX",
        "exportcsv": "Exporter CSV"
    }
  },
  "de": {
    "border": "Rahmen",
    "margin": "Verhältnis",
    "function": "Funktion",
    "distriRow": "Zeilen verteilen",
    "distriCol": "Spalten verteilen",
    "import": "Importieren",
    "export": "Exportieren",
    "borderList": {
        "noBorder": "Kein Rahmen",
        "bottomBorder": "Rahmenlinie unten",
        "allBorder": "Alle Rahmenlinien",
        "topBorder": "Rahmenlinie oben",
        "outsizeBorder": "Aussenrahmen",
        "leftBorder": "Rahmenlinie links",
        "insideBorder": "Rahmenlinien innen",
        "rightBorder": "Rahmenlinie rechts ",
        "horizontalBorder": "Innere horizontale Rahmenlinie",
        "downBorder": "Diagonaler unterer Rahmen",
        "verticalBorder": "Innerer vertikaler Rahmen",
        "upBorder": "Oberer diagonaler Rahmen"
    },
    "marginList": {
        "noneMargin": "Keinen Seitenrand",
        "narrowMargin": "Eng",
        "normalMargin": "Normal ",
        "wideMargin": "Mittlere Breite"
    },
    "sumList": {
        "sum": "SUMME",
        "average": "Durchschnitt",
        "max": "Maximum",
        "min": "Minimum"
    },
    "exportList": {
        "exportExcel": "XLSX exportieren",
        "exportcsv": "CSV exportieren"
    }
  },
  "jp": {
    "border": "罫線",
    "margin": "余白",
    "function": "関数",
    "distriRow": "幅を揃える",
    "distriCol": "高さを揃える",
    "import": "インポート",
    "export": "エクスポート",
    "borderList": {
        "noBorder": "枠なし",
        "bottomBorder": "下罫線",
        "allBorder": "格子",
        "topBorder": "上罫線",
        "outsizeBorder": "外枠",
        "leftBorder": "左罫線",
        "insideBorder": "内枠",
        "rightBorder": "右罫線",
        "horizontalBorder": "内部横罫線",
        "downBorder": "対角線罫線",
        "verticalBorder": "内部縦罫線",
        "upBorder": "対角線罫線"
    },
    "marginList": {
        "noneMargin": "なし",
        "narrowMargin": "狭い",
        "normalMargin": "標準",
        "wideMargin": "広い"
    },
    "sumList": {
        "sum": "SUM",
        "average": "AVERAGE",
        "max": "MAX",
        "min": "MIN"
    },
    "exportList": {
        "exportExcel": "XLSXにエクスポート",
        "exportcsv": "CSVにエクスポート"
    }
  },
  "es": {
    "border": "Frontera",
    "margin": "Margen",
    "function": "Función",
    "distriRow": "Distribuya las filas",
    "distriCol": "Distribuir columnas",
    "import": "Importar",
    "export": "Exportar",
    "borderList": {
        "noBorder": "Sin Fronteras",
        "bottomBorder": "Frontera inferior",
        "allBorder": "Todas las fronteras",
        "topBorder": "Frontera superior",
        "outsizeBorder": "Fuera de las fronteras",
        "leftBorder": "Frontera izquierda",
        "insideBorder": "Dentro de las fronteras",
        "rightBorder": "Frontera derecha",
        "horizontalBorder": "Dentro de la frontera horizontal",
        "downBorder": "frontera diagonal hacia abajo",
        "verticalBorder": "Dentro de la frontera vertical",
        "upBorder": "Diagonal arriba de la frontera"
    },
    "marginList": {
        "noneMargin": "Sin margen",
        "narrowMargin": "Estrecho",
        "normalMargin": "Normal",
        "wideMargin": "Ancho de margen"
    },
    "sumList": {
        "sum": "Suma",
        "average": "Promedio",
        "max": "Máximo",
        "min": "Mínimo"
    },
    "exportList": {
        "exportExcel": "Exportar XLSX",
        "exportcsv": "Exportar CSV"
    }
  },
  "pt": {
    "border": "Margem",
    "margin": "Limite",
    "function": "Função",
    "distriRow": "Distribuir Linhas",
    "distriCol": "Distribuir Colunas",
    "import": "Importar",
    "export": "Exportar",
    "borderList": {
        "noBorder": "Sem Margem",
        "bottomBorder": "Margem Inferior",
        "allBorder": "Todas as Margens",
        "topBorder": "Margem Superior",
        "outsizeBorder": "Margens Exteriores",
        "leftBorder": "Margem Esquerda",
        "insideBorder": "Margens Interiores",
        "rightBorder": "Margem Direita",
        "horizontalBorder": "Margem Horizontal Interior",
        "downBorder": "Margem Diagonal Para Baixo",
        "verticalBorder": "Margem Vertical Interior",
        "upBorder": "Margem Diagonal Para Cima"
    },
    "marginList": {
        "noneMargin": "Sem Limite",
        "narrowMargin": "Estreito",
        "normalMargin": "Normal",
        "wideMargin": "Largura do Limite"
    },
    "sumList": {
        "sum": "Soma",
        "average": "Média",
        "max": "Máximo",
        "min": "Mínimo"
    },
    "exportList": {
        "exportExcel": "Exportar XLSX",
        "exportcsv": "Exportar CSV"
    }
  },
  "it": {
    "border": "Bordo",
    "margin": "Margine",
    "function": "Funzione",
    "distriRow": "Distribuisci Righe",
    "distriCol": "Distribuisci Colonne",
    "import": "Importa",
    "export": "Esporta",
    "borderList": {
        "noBorder": "Nessun Bordo",
        "bottomBorder": "Bordo Inferiore",
        "allBorder": "Tutti i Bordi",
        "topBorder": "Bordo Superiore",
        "outsizeBorder": "Bordo Esterno",
        "leftBorder": "Bordo Sinistro",
        "insideBorder": "Bordi Interni",
        "rightBorder": "Bordo Destro",
        "horizontalBorder": "Bordo Interno Orizzontale",
        "downBorder": "Bordo Diagonale Verso il Basso",
        "verticalBorder": "Bordo Interno Verticale",
        "upBorder": "Bordo Diagonale Verso l'Alto"
    },
    "marginList": {
        "noneMargin": "Nessun Margine",
        "narrowMargin": "Stretto",
        "normalMargin": "Normale",
        "wideMargin": "Larghezza Margine"
    },
    "sumList": {
        "sum": "Somma",
        "average": "Media",
        "max": "Massimo",
        "min": "Minimo"
    },
    "exportList": {
        "exportExcel": "Esporta come XLSX",
        "exportcsv": "Esporta come CSV"
    }
  },
  "tw": {
    "border": "邊框",
    "margin": "邊界",
    "function": "函數",
    "distriRow": "平均分佈行",
    "distriCol": "平均分佈列",
    "import": "導入",
    "export": "導出",
    "borderList": {
        "noBorder": "無框線",
        "bottomBorder": "下框線",
        "allBorder": "所有框線",
        "topBorder": "上框線",
        "outsizeBorder": "外側框線",
        "leftBorder": "左框線",
        "insideBorder": "內部框線",
        "rightBorder": "右框線",
        "horizontalBorder": "內部橫框線",
        "downBorder": "斜下框線",
        "verticalBorder": "內部豎框線",
        "upBorder": "斜上框線"
    },
    "marginList": {
        "noneMargin": "無",
        "narrowMargin": "窄",
        "normalMargin": "普通",
        "wideMargin": "寬"
    },
    "sumList": {
        "sum": "和",
        "average": "平均",
        "max": "最大",
        "min": "最小"
    },
    "exportList": {
        "exportExcel": "導出XLSX",
        "exportcsv": "導出CSV"
    }
  }
}
</i18n>
